module.exports = __webpack_public_path__ + "img/GitHub-Dark.c06b7eed.png";